import cx from 'classnames';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {
  selectGroupIsFull,
  selectGroupIsPast,
  selectSignupOptionIsFull,
  selectSignupOptionIsPast,
  sheetIsArchived,
} from '~/SignUpSheets/reducers/sheet/selectors';
import {Typography} from '~library/atoms/Typography';
import './GroupAvailabilityTag.sass';

export const GroupAvailabilityTag = ({groupId, signupOption, className}) => {
  const groupIsPast = useSelector(selectGroupIsPast(groupId));
  const groupIsFull = useSelector(selectGroupIsFull(groupId));
  const slotIsPast = useSelector(selectSignupOptionIsPast(signupOption));
  const slotIsFull = useSelector(selectSignupOptionIsFull(signupOption));
  const isArchived = useSelector(sheetIsArchived);

  const isPast = groupIsPast || (!groupId && slotIsPast);
  const isFull = groupIsFull || (!groupId && slotIsFull);

  let tagText = 'Signups Available';
  if (isArchived) tagText = '';
  else if (isPast) tagText = 'Signup Passed';
  else if (isFull) tagText = 'Signup Full';

  return (
    <Typography
      variant="label2"
      size="small"
      color={isPast || isFull ? 'coin' : 'emeraldWebText'}
      className={cx('group-availability-tag', className)}
    >
      {tagText}
    </Typography>
  );
};

GroupAvailabilityTag.propTypes = {
  groupId: PropTypes.string,
  signupOption: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    item: PropTypes.string,
    date: PropTypes.string,
    description: PropTypes.string,
    // biome-ignore lint/style/useNamingConvention: existing error
    position_index: PropTypes.number,
    title: PropTypes.string,
    // biome-ignore lint/style/useNamingConvention: existing error
    all_day: PropTypes.bool,
    slots: PropTypes.arrayOf(
      PropTypes.shape({
        // biome-ignore lint/style/useNamingConvention: existing error
        slot_id: PropTypes.string,
        title: PropTypes.string,
        // biome-ignore lint/style/useNamingConvention: existing error
        start_time: PropTypes.string,
        // biome-ignore lint/style/useNamingConvention: existing error
        end_time: PropTypes.string,
        description: PropTypes.string,
        // biome-ignore lint/style/useNamingConvention: existing error
        product_link: PropTypes.shape({
          url: PropTypes.string,
          // biome-ignore lint/style/useNamingConvention: existing error
          display_text: PropTypes.string,
          // biome-ignore lint/style/useNamingConvention: existing error
          not_safe: PropTypes.bool,
        }),
      })
    ),
  }),
  className: PropTypes.string,
};
